"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdditionalFilesDef = void 0;
const joi_1 = __importDefault(require("joi"));
const __1 = require("..");
exports.AdditionalFilesDef = Object.assign(Object.assign({}, __1.daoObjSchemaDef), { fileBusinessId: joi_1.default.object({
        businessUnitId: joi_1.default.string().required(),
        centreId: joi_1.default.string().required(),
        seriesId: joi_1.default.number().required(),
        assessmentCode: joi_1.default.string().required(),
        componentNumber: joi_1.default.string().required(),
    }), learnerNumber: joi_1.default.number().required(), learnerUniqueId: joi_1.default.string().required(), s3Key: joi_1.default.string().required(), virusScanState: joi_1.default.string().required(), additionalInfo: joi_1.default.object({
        qualification: joi_1.default.string().required(),
        assessment: joi_1.default.string().required(),
        componentName: joi_1.default.string().required(),
        originalName: joi_1.default.string().optional(),
        fileSize: joi_1.default.number().optional(),
    }), uploaded: joi_1.default.string().required(), submittedAt: joi_1.default.string().optional(), lastUpdated: joi_1.default.string().optional(), uploader: joi_1.default.object({
        name: joi_1.default.string().optional(),
        email: joi_1.default.string().optional(),
    }) });
